export const FIELD_PLACEHOLDER_VALUE = 'select field...';
export const SOURCESYSTEMS_PLACEHOLDER_VALUE = 'select source system...';
export const VERB_PLACEHOLDER_VALUE = 'select condition...';
export const OBJECT_PLACEHOLDER_VALUE = 'select object...';
export const SUBJECT_PLACEHOLDER_VALUE = 'select subject...';
// You can update / discover the regex expression on https://www.regextester.com
export const CONDITION_LOGIC_CHECK_REGEX = /^(((\([ ]*)*\$\d*)(([ ]+(AND|OR)[ ]+(\$\d*(\)[ ]*)*))*[ ]+(AND|OR)+[ ]+)*)*(\$\d*(\)[ ]*)*$)/i;
